<template>
    <div class="form">
        <h4 class="step-title">
            Do you have car insurance?
        </h4>
        <div class="step-content d-flex flex-column flex-md-row">
            <yes-no-button-list v-bind:onclick="complete"></yes-no-button-list>
        </div>
    </div>
</template>

<script>
    import YesNoButtonList from "./shared/YesNoButtonList.vue"

    export default {
        name: "IsInsured",
        components: {
            YesNoButtonList
        },
        props: {
            lead: Object
        },
        methods: {
          complete: function(isInsured) {
              this.lead.isInsured = isInsured;
              this.$emit("complete", this.$options.name, isInsured);
          }
        }
    }
</script>
